import { combineReducers } from "redux";
import { CohortActions } from "../types/cohort-actions";
import { DiscussionRecordingActions } from "../types/discussion-recording-actions";
import { SharedRecording } from "../types/shared-recording";

export function items(state: SharedRecording[]=[], action: DiscussionRecordingActions | CohortActions) {
    switch(action.type) {
        case 'discussion-recordings/fetch-list-success':
            return action.data;
        case 'discussion-recordings/loadmore-list-success':
            if (action.data.length > 0) {
                return [...state, ...action.data];
            } else {
                return state;
            }
        case 'cohorts/change-request':
            return [];
        default:
            return state;
    }
}

function isFetching(state = false, action: DiscussionRecordingActions) {
    switch(action.type) {
        case 'discussion-recordings/fetch-list-request':
        case 'discussion-recordings/loadmore-list-request':
            return true;
        case 'discussion-recordings/fetch-list-success':
        case 'discussion-recordings/fetch-list-error':
        case 'discussion-recordings/loadmore-list-success':
        case 'discussion-recordings/loadmore-list-error':
            return false;
        default:
            return state;
    }
}

function lastFetched(state:number | null = null, action: DiscussionRecordingActions | CohortActions) {
    switch(action.type) {
        case 'discussion-recordings/fetch-list-success':
            return Date.now() + ( 5 * 60 * 1000); //5mins
        case 'cohorts/change-request':
            return null;
        default:
            return state;
    }
}

function allFetched(state = false, action: DiscussionRecordingActions | CohortActions) {
    switch(action.type) {
        case 'discussion-recordings/loadmore-list-success':
            return action.data.length === 0
        case 'cohorts/change-request':
            return false;
        default:
            return state;
    }
}

export const discussionRecordings = combineReducers({
    items,
    isFetching,
    lastFetched,
    allFetched
});